export default __webpack_public_path__ + "static/media/1.1ca6541a.png";